import { createContext, useContext } from "react";

type RouteSwitchContextValue = {
    register: (id: string) => boolean;
};

export const RouteSwitchContext = createContext<RouteSwitchContextValue | null>(null);

export function useRouteSwitch() {
    return useContext(RouteSwitchContext);
}
